var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invoice)?_c('DocumentSheet',{attrs:{"doc":_vm.invoice,"type":"invoice","docHandlerTitle":"ผู้อนุมัติ"}}):_c('p',[_vm._v("\n  Getting your Invoice.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }